(function($) {
	'use strict';
	$.fn.Collection__DownloadAllImages = function() {
		this.each(function() { 
			
			/*
			 * Action: Download All Images
			 * Note: This is handled with URLs
			 */
			var $self = $(this);
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function() {
				// e.preventDefault();
				
				$.Globals.track_event( 'Downloading All Images in a collection' );
				
			});
			
		
		});
		return this;
	};
}(jQuery));